import * as React from 'react';
import {HeaderSortDirection, ReactTableState} from "./ReactTable";
import {getReactButton, getReactTableLocal} from "../../index";
import {RefObject} from "react";

interface ReactMultiSelectSearchAsYouTypeData {
    id?: string,
    label?: string,
    tableLabel?: string,
    divContainerCSS?: string,
    divTableContainerCSS?: string,
    divSAYTTableContainerCSS?: string,
    style?: {},
    tableStyle?: {},
    saytTableStyle?: {},
    labelStyle?: {},
    labelCSS?: (selectedRecordIndex: number) => string,
    textStyle?: {},
    headers?: any[],
    headersCSS?: string,
    rowsCSS?: (row: any, rowIndex: number) => string,
    rowsStyle?: (row: any, rowIndex: number) => {},
    selectionHeaders?: any[],
    selectionHeadersCSS?: string,
    selectionRowsCSS?: (row: any, rowIndex: number) => string,
    selectionRowsStyle?: (row: any, rowIndex: number) => {},
    rows?: any[],
    tabIndex?: null,
    highlightSelectedRow?: number, // -1 to turn off
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string,
    selectRecordWithRowClick?: boolean,
    toolBarDisplayHeader?: boolean,
    toolBarDisplayFooter?: boolean,
    toolBarNumToDisplay?: number,
    selectColumns?: [],
    onSAYTClickEvent?: (row: any) => {},
    hideSearchOnSelect?: boolean,
    showSearchButton?: boolean,
    searchButtonTabIndex?: null,
    disabled?: boolean,
    disableHeaderScrolling?: boolean,
    disableID?: string,
    refreshID?: string,
    toolBarRefreshID?: string,
    refreshSAYTTableID?: string,
    onRefresh?: () => {},
    onToolBarRefresh?: () => {},
    noRecordsSelectedText?: string,
    addCustomFilterOptions?: object,
    customFilter?: (row: any) => boolean,
    onFocusOut?: () => null,
    isSelectedKey?: string,
    customFilterCSS?: string,
    onSortEvent?: () => void,
    selectHeaderClick?: () => void,
    onSAYTTableDisplayEvent?: (tableObj: object) => {},
    divSAYTWindowCSS?: string,
    onBeforeSAYTTableDisplayEvent?: () => null,
}

interface ReactMultiSelectSearchAsYouTypeState {
    showTable: boolean,
    searchValue: string,
    highlightSelectedRow: number,
    toolBarPageNumber: number,
    toolBarPageNumberTyped: number,
    rows: any[], // All Rows
    selectedRows: any[], // Displayed Selected Table Rows
    headers: any[],
    filteredRows: any[], // Displayed SAYT Table Rows
    disabled: boolean
}

export class ReactMultiSelectSearchAsYouType extends React.Component<ReactMultiSelectSearchAsYouTypeData> {
    useHighlightSelectedRow: boolean;
    inputRef: RefObject<any>;

    constructor(props: ReactMultiSelectSearchAsYouTypeData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.updateSAYT = this.updateSAYT.bind(this);
        this.onSelectCellClick = this.onSelectCellClick.bind(this);
        this.onClick = this.onClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.filterTable = this.filterTable.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.toolBarUpdate = this.toolBarUpdate.bind(this);
        this.sortUpdate = this.sortUpdate.bind(this);
        this.toolBarPageLeft = this.toolBarPageLeft.bind(this);
        this.toolBarPageRight = this.toolBarPageRight.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.unselectAll = this.unselectAll.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onRefreshSAYTOnly = this.onRefreshSAYTOnly.bind(this);

        this.inputRef = React.createRef();
        this.useHighlightSelectedRow = props.highlightSelectedRow >= 0;
        this.state = {
            rows: props.rows,
            showTable: false,
            searchValue: '',
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
            filteredRows: this.filterTable('', props.rows),
            selectedRows: props.rows.filter(row => {return this.filterUnselected(row);}),
            disabled: props.disabled
        };
    }

    componentDidMount() {
        // Add Selection checkbox cells
        if(this.props.selectColumns.length > 0) {
            this.setState(() => {
                return {
                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                    filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
                    selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);})
                }
            });
        }
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactMultiSelectSearchAsYouTypeData) {
        this.setState({
            disabled: props.disabled,
            rows: props.rows,
            selectedRows: props.rows.filter(row => {return this.filterUnselected(row);})
        });
    }

    // Removes rows that are not selected from the Selection Table
    filterUnselected(row: any) {
        return (null != row[this.props.isSelectedKey] && row[this.props.isSelectedKey] == true);
    }

    updateSAYT(rowIndex: number, setSelected: boolean) {
        if(rowIndex >= 0) {
            (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] = setSelected;
            this.setState({
                    searchValue: '',
                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                    selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
                    highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                    toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                    toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            }, () => {
                if (null != this.props.onSAYTClickEvent) {
                    this.props.onSAYTClickEvent((this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex]);
                }
            });
        }
    }

    // SAYT was clicked, display the search table
    onClick() {
        this.inputRef.current.focus();

        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
            this.props.onBeforeSAYTTableDisplayEvent();
        }

        this.setState({
            showTable: true,
            searchValue: '',
            filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
            selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
            highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        });

        // Add a mousedown event to trigger once we click away from the SAYT
        const targetElement = $(this.inputRef.current);
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            if(targetElement.closest('div').find($(event2.target)).length < 1) {
                this.onFocusOut();
            }
        });
    }

    // User changed something in the SAYT Text field
    handleChange(event: any) {
        this.setState({
            showTable: true,
            searchValue: event.target.value,
            rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
            filteredRows: this.filterTable(event.target.value, (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
            selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
            headers: (this.state as ReactMultiSelectSearchAsYouTypeState).headers,
            highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        });
    }

    // Filter using the Search String
    searchCell(header: any, row: any, searchValLowerCase: string) {
        let searchKey = (null != header.displayKey) ? header.displayKey : '';
        if(null != header.hiddenSearchKey) {
            searchKey = header.hiddenSearchKey;
        }

        // Some columns can be excluded from the search (by default all columns are searched on)
        if(null != header.disableSearch) {
            return false
        } else if(searchKey.length > 0 && row[searchKey]) {
            if(typeof row[searchKey] == "string") {
                return row[searchKey].toLowerCase().includes(searchValLowerCase);
            } else if(typeof row[searchKey] == "number") {
                return row[searchKey].toString().includes(searchValLowerCase);
            } else if(null != row[searchKey].props) {
                if(null != row[searchKey].props.value) {
                    return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                }
            }
        }
        return false;
    }

    searchRow(row: any[], searchValLowerCase: string) {
        let skipCustomFilter = true;

        // Filter using the customFilter in addition to the SAYT
        if(null != this.props.customFilter) {
            skipCustomFilter = this.props.customFilter(row);
        }

        // Filter using the SAYT
        return skipCustomFilter && ((searchValLowerCase.length > 0) ? this.props.headers.map((header) => this.searchCell(header, row, searchValLowerCase)).includes(true) : true);
    }

    // Filter the rows off of the SAYT and off of the customFilter if it exists
    filterTable(searchVal: string, rows: any[]) {
        const searchValLowerCase = (searchVal.length > 0) ? searchVal.toLowerCase() : '';
        return rows.filter(row => this.searchRow(row, searchValLowerCase.trim()));
    }

    onFocusIn(event: any) {
        const targetElement = $(event.target);

        // Add a mousedown event to trigger once we click away from the SAYT
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            if(targetElement.closest('div').find($(event2.target)).length < 1) {
                this.onFocusOut();
            }
        });
    }

    onFocusOut() {
        // Remove mousedown event listener that was added when we displayed the SAYT Search Table
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).off(clickEvent);

        this.setState({
            searchValue: '',
            rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
            showTable: false
        });

        // Call focus out function if one exists
        if(this.props.onFocusOut) {
            this.props.onFocusOut();
        }
    }

    // Get the next row to highlight for the highlightSelectedRow
    getNextRow(rowIndex: number, keyUp: boolean, totalRows: number) {
        let nextRow = rowIndex;
        if(keyUp) {
            if(nextRow > 0) {
                nextRow--;
            }
        } else {
            if(nextRow < (totalRows - 1)) {
                nextRow++;
            }
        }
        return nextRow;
    }

    toolBarPageLeft() {
        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            toolBarPageNumber: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            toolBarPageNumberTyped: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((prev.toolBarPageNumber > 1) ? 0 : (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    toolBarPageRight() {
        const totalPages = Math.ceil((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber),
            toolBarPageNumberTyped: (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber < totalPages) ? 0 : (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    toolBarUpdate(props: ReactTableState) {
        this.setState(() => ({
            toolBarPageNumber: props.toolBarPageNumber,
            toolBarPageNumberTyped: props.toolBarPageNumberTyped,
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((props.highlightSelectedRow >= 0) ? props.highlightSelectedRow : 0) : -1)
        }));
    }

    sortUpdate(props: ReactTableState) {
        this.setState(() => ({
            filteredRows: this.filterTable((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue, props.rows),
            selectedRows: props.rows.filter(row => {return this.filterUnselected(row);}),
        }));
        this.toolBarUpdate(props);
    }

    // User typed something in the SAYT Text field
    onKeyPress(event: any) {
        const keyUp = event.key == "ArrowUp";
        const keyDown = event.key == "ArrowDown";
        const keyLeft = event.key == "ArrowLeft";
        const keyRight = event.key == "ArrowRight";
        const keyTab = event.key == "Tab";
        const keyEsc = event.key == "Escape";
        const keyEnter = event.key == "Enter";
        const keyDelete = event.key == "Delete";
        const keyBackspace = event.key == "Backspace";
        const keyIsInvisible = ((event.key == "Backspace") || (event.key == "Delete") || (event.key == "Shift") || (event.key == "CapsLock") || (event.key == "Control") || (event.key == "Alt"));
        const resetSearchList = ((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue.length == 0 && keyIsInvisible && (this.state as ReactMultiSelectSearchAsYouTypeState).showTable);
        let keyPressed = false;

        // If the table is not displayed, determine if the key pressed should display it
        // Special keys like "Shift" should not display the table
        if(resetSearchList || ((event.key.length == 1 || (keyUp || keyDown || keyLeft || keyRight || keyEnter || keyDelete || keyBackspace)) && !(this.state as ReactMultiSelectSearchAsYouTypeState).showTable)) {
            if(!(this.state as ReactMultiSelectSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
                this.props.onBeforeSAYTTableDisplayEvent();
            }

            this.setState({
                showTable: true,
                searchValue: '',
                filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
                highlightSelectedRow: ((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1
            });
        } else if (this.useHighlightSelectedRow && (keyUp || keyDown)) {
            // Adjust the highlight row selected
            let updateHighlightPosition = true;
            let newSelectedRow = this.getNextRow((this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow, keyUp, (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length);

            // Adjust the page number if needed
            let pageNumber = (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber;
            if(keyUp && pageNumber > 1 && (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow == 0) {
                newSelectedRow = this.props.toolBarNumToDisplay - 1;
                pageNumber--;
            } else if(keyDown) {
                if((newSelectedRow + ((pageNumber - 1) * this.props.toolBarNumToDisplay)) <= ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length - 1)) {
                    if(newSelectedRow >= this.props.toolBarNumToDisplay) {
                        const totalPages = Math.ceil((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
                        if (pageNumber < totalPages) {
                            newSelectedRow = 0;
                            pageNumber++;
                        } else {
                            updateHighlightPosition = false;
                        }
                    }
                } else {
                    updateHighlightPosition = false;
                }
            }

            keyPressed = true;

            // If the highlight position should be adjusted update the state
            if(updateHighlightPosition) {
                this.setState({
                    highlightSelectedRow: newSelectedRow,
                    toolBarPageNumber: pageNumber,
                    toolBarPageNumberTyped: pageNumber
                });
            }
        } else if (keyLeft || keyRight) {
            // Update the page number using the left and right keyboard arrow keys
            if (keyLeft) {
                this.toolBarPageLeft();
                keyPressed = true;
            } else if (keyRight) {
                this.toolBarPageRight();
                keyPressed = true;
            }
        } else if(keyTab || keyEsc) {
            this.onFocusOut();
        } else if(keyEnter) {
            // Select the highlight selected row on enter
            if(this.useHighlightSelectedRow) {
                const selectIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow + (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                if(selectIndex >= 0 && selectIndex < (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) {
                    const filteredRow = (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[selectIndex];
                    this.onSelectCellClick(filteredRow, event.shiftKey, event.ctrlKey, true);
                }
                keyPressed = true;
            }
        }

        if (keyPressed) {
            event.preventDefault();
        }
    }

    onSelectCellClick(row: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean) {
        const rowIndex = this.indexOfRow(row);

        // If the table is Disabled don't allow row selecting
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            if (rowIndex >= 0) {
                let isSelected = true;
                if((null != (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey]) && ('undefined' != (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey])) {
                    isSelected = (applySelection) ? !(this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] : (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey];
                }

                this.updateSAYT(rowIndex, isSelected);
            }
        }
    }

    // Get the index of the first selected row
    indexOfSelected() {
        let index = -1;

        for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeData).rows.length; i++) {
            if((this.state as ReactMultiSelectSearchAsYouTypeData).rows[i][this.props.isSelectedKey]) {
                return i;
            }
        }

        return index;
    }

    // Disable/enable the MultiSelect SAYT
    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    // Refresh both SAYT and Selection Tables
    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            filteredRows: this.filterTable(prev.searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
            selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }));
    }

    // Refresh the SAYT table and not the Selection Table
    onRefreshSAYTOnly() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState((prev: ReactMultiSelectSearchAsYouTypeState) => ({
            filteredRows: this.filterTable(prev.searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }));
    }

    // Get the index of the row in the rows array
    indexOfRow(row: any) {
        for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
            if(row == (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    // Unselect all records in the rows array
    unselectAll() {
        // Do nothing if the table is Disabled
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            // Unselect all of the rows (even rows filtered and rows off page)
            for(let i = 0; i < (this.state as ReactMultiSelectSearchAsYouTypeState).rows.length; i++) {
                (this.state as ReactMultiSelectSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = false;
            }

            // Update the current state
            this.setState({
                searchValue: '',
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: this.filterTable('', (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
                highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            });

            if(null != this.props.selectHeaderClick) {
                this.props.selectHeaderClick();
            }
        }
    }

    // Select/Unselect all displayed rows
    selectAll() {
        // Do nothing if the table is Disabled
        if(!(this.state as ReactMultiSelectSearchAsYouTypeState).disabled) {
            const startingIndex = (((this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            let endingIndex = startingIndex + this.props.toolBarNumToDisplay;
            if (endingIndex > (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length) {
                endingIndex = (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length;
            }

            // Use the first row currently displayed (using the startingIndex) to determine if we should mark all displayed rows as selected or unselected
            const markAsSelected = ((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows.length > 0) ? !(((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.isSelectedKey]) ? (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[startingIndex][this.props.isSelectedKey] : false) : false;

            // Mark all of the rows displayed as Selected/Unselected
            for (let i = startingIndex; i < endingIndex; i++) {
                const rowIndex = this.indexOfRow((this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows[i]);
                if (rowIndex >= 0) {
                    (this.state as ReactMultiSelectSearchAsYouTypeState).rows[rowIndex][this.props.isSelectedKey] = markAsSelected;
                }
            }

            // Update the current state
            this.setState({
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: this.filterTable((this.state as ReactMultiSelectSearchAsYouTypeState).searchValue, (this.state as ReactMultiSelectSearchAsYouTypeState).rows),
                selectedRows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows.filter(row => {return this.filterUnselected(row);}),
                highlightSelectedRow: (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow,
                toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped
            });

            if(null != this.props.selectHeaderClick) {
                this.props.selectHeaderClick();
            }
        }
    }

    buildLabel() {
        return <label style={this.props.labelStyle} className={(null != this.props.labelCSS) ? this.props.labelCSS(this.indexOfSelected()) : ""}>
            {this.props.label}
        </label>
    }

    buildSearchButton() {
        return <button id={this.props.id + "_search"} className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactMultiSelectSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.searchButtonTabIndex} type="button" title="Search" onClick={this.onClick} disabled={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}>
            <span className="ui-button-icon ui-icon ui-icon-search"></span><span className="ui-button-icon-space"></span>
            Search
        </button>;
    }

    render() {
        // Render the MultiSelect SAYT (Note there are two internal tables, one for the selection and one for the searching)
        return <div className={this.props.divContainerCSS} style={this.props.style}>
            {this.buildLabel()}
            <div style={{paddingBottom: '5px'}}>
                {<table className="categoryAllHide"><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        onChange={this.onDisableClick}
                        checked={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                </tr></table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                {getReactButton({id: this.props.refreshSAYTTableID, css: "categoryAllHide", onClick: this.onRefreshSAYTOnly, text: "HIDDEN SAYT REFRESH BUTTON"})}
                <tr>
                    <td>
                        <table >
                            <tr>
                                <td>
                                    <input ref={this.inputRef} id={this.props.id} type="text" value={(this.state as ReactMultiSelectSearchAsYouTypeState).searchValue} tabIndex={this.props.tabIndex} style={this.props.textStyle} onClick={this.onClick} onChange={this.handleChange} onKeyDown={this.onKeyPress} onFocus={this.onFocusIn} disabled={(this.state as ReactMultiSelectSearchAsYouTypeState).disabled}/>
                                </td>
                                <td style={{verticalAlign: "middle", paddingLeft: "4px"}}>
                                    {(this.props.showSearchButton) ? this.buildSearchButton() : null}
                                </td>
                            </tr>
                            <tr id={this.props.id + '_saytTable_saytTableShell'}>
                                {((this.state as ReactMultiSelectSearchAsYouTypeState).showTable) ? getReactTableLocal({
                                    id: this.props.id + '_saytTable',
                                    addSelectColumn: true,
                                    selectHeaderClick: this.selectAll,
                                    style: this.props.saytTableStyle,
                                    highlightSelectedRow: ((this.useHighlightSelectedRow) ? (this.state as ReactMultiSelectSearchAsYouTypeState).highlightSelectedRow : -1),
                                    toolBarPageNumber: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumber,
                                    toolBarPageNumberTyped: (this.state as ReactMultiSelectSearchAsYouTypeState).toolBarPageNumberTyped,
                                    selectColumns: this.props.selectColumns,
                                    headers: this.props.selectionHeaders,
                                    headersCSS: this.props.selectionHeadersCSS,
                                    rowsCSS: this.props.selectionRowsCSS,
                                    rowsStyle: this.props.selectionRowsStyle,
                                    rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                                    filteredRows: (this.state as ReactMultiSelectSearchAsYouTypeState).filteredRows,
                                    showTable: (this.state as ReactMultiSelectSearchAsYouTypeState).showTable,
                                    isSearchAsYouType: true,
                                    toolBarNumToDisplay: this.props.toolBarNumToDisplay,
                                    toolBarDisplayHeader: this.props.toolBarDisplayHeader,
                                    toolBarDisplayFooter: this.props.toolBarDisplayFooter,
                                    toolBarDisplayCompact: true,
                                    hideSAYTOnSelect: this.props.hideSearchOnSelect,
                                    onSelectCellClick: this.onSelectCellClick,
                                    toolBarUpdate: this.toolBarUpdate,
                                    sortUpdate: this.sortUpdate,
                                    onSortEvent: this.props.onSortEvent,
                                    disableHeaderScrolling: this.props.disableHeaderScrolling,
                                    noRecordsSelectedText: this.props.noRecordsSelectedText,
                                    addCustomFilterOptions: this.props.addCustomFilterOptions,
                                    customFilterCSS: this.props.customFilterCSS,
                                    divContainerCSS: this.props.divSAYTTableContainerCSS,
                                    toolBarRefreshID: this.props.toolBarRefreshID,
                                    onToolBarRefresh: this.props.onToolBarRefresh,
                                    selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                                    isSelectedKey: this.props.isSelectedKey,
                                    hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                                    onSAYTTableDisplayEvent: this.props.onSAYTTableDisplayEvent,
                                    divSAYTWindowCSS: this.props.divSAYTWindowCSS,
                                }) : null}
                            </tr>
                        </table>
                    </td>
                </tr>
            </div>
            {getReactTableLocal({
                id: this.props.id + '_table',
                showTable: true,
                tableLabel: this.props.tableLabel,
                addSelectColumn: true,
                selectHeaderClick: this.unselectAll,
                style: this.props.tableStyle,
                disabled: (this.state as ReactMultiSelectSearchAsYouTypeState).disabled,
                headers: this.props.headers,
                headersCSS: this.props.headersCSS,
                rowsCSS: this.props.rowsCSS,
                rowsStyle: this.props.rowsStyle,
                rows: (this.state as ReactMultiSelectSearchAsYouTypeState).rows,
                filteredRows: (this.state as ReactMultiSelectSearchAsYouTypeState).selectedRows,
                highlightSelectedRow: -1,
                sortUpdate: this.sortUpdate,
                selectColumns: this.props.selectColumns,
                onSelectCellClick: this.onSelectCellClick,
                disableHeaderScrolling: this.props.disableHeaderScrolling,
                noRecordsSelectedText: this.props.noRecordsSelectedText,
                divContainerCSS: this.props.divTableContainerCSS,
                selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                isSelectedKey: this.props.isSelectedKey,
                hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                onSortEvent: this.props.onSortEvent,
            })}
        </div>;
    }
}
